import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';
import { candidateSearchDPRoot } from '../candidate-search/candidate-search.meta';

const dpRoot = `${candidateSearchDPRoot}|Demographic`;

export type CandidateSearchDemograhpicLocs = 'SPCandidateSearchDemographicErrorCombinedStrings';

export const candidateSearchDemographicLocs: LocDefs<CandidateSearchDemograhpicLocs> = {
	SPCandidateSearchDemographicErrorCombinedStrings: {
		defaultValue: 'First and last names must contain at least 2 characters total',
		description: 'Link to view the edited exam in the candidate log.',
		displayPath: `${dpRoot}|String Combined Error`,
		displayType: 'Error',
		htmlAllowed: true,
		feature: HubFeature.Core,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<CandidateSearchDemograhpicLocs>(candidateSearchDemographicLocs);
